export class UnLockInfoModel {
    message: string;
    userId: number;
    userName: string;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/models/unLock-info-model.ts